// extracted by mini-css-extract-plugin
export default {"container":"CustomSpinner_container__ttxC+"};